import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class EnvironmentHelper {
  public API_BASE_URL: string;
  environment = environment.environment;

  constructor() {
    this.API_BASE_URL = environment.API_BASE_URL;
  }

  public get apiBaseUrl(): string {
    const result =
      this.API_BASE_URL + (this.API_BASE_URL.endsWith("/") ? "" : "/");

    return result;
  }
}
